import axios from "axios";

const BASE_URL = import.meta.env.VITE_BASE_API_URL;

// Plain HTTP client for public endpoints — no auth, no auto-reload on errors
const http = axios.create({
  baseURL: BASE_URL,
});

http.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default http;
